import { render, staticRenderFns } from "./BigSelect.vue?vue&type=template&id=dbab1c88&scoped=true"
import script from "./BigSelect.vue?vue&type=script&lang=js"
export * from "./BigSelect.vue?vue&type=script&lang=js"
import style0 from "./BigSelect.vue?vue&type=style&index=0&id=dbab1c88&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dbab1c88",
  null
  
)

export default component.exports